if (!customElements.get('icraft-home-film')) {
  class IcraftHomeFilm extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role=status]');
      this.onHidden = () => { if (document.hidden) this.video?.pause(); };
      document.addEventListener('visibilitychange', this.onHidden);
      this.observer = new IntersectionObserver(([entry]) => { if (!entry.isIntersecting) this.video?.pause(); });
      this.observer.observe(this);
      this.button.addEventListener('click', () => this.play());
    }
    disconnectedCallback() {
      this.video?.pause(); this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onHidden); this.ready = false;
    }
    async play() {
      if (!this.video) {
        this.append(this.querySelector('template').content.cloneNode(true));
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.removeAttribute('loading');
        this.video.addEventListener('play', () => {
          document.querySelectorAll('icraft-home-film video').forEach((video) => { if (video !== this.video) video.pause(); });
          this.status.hidden = true;
        });
        this.video.addEventListener('error', () => {
          this.status.textContent = 'The video could not load. Please try again.'; this.status.hidden = false;
          this.video.remove(); this.video = null; this.button.hidden = false;
        });
      }
      this.button.hidden = true;
      this.video.setAttribute('tabindex', '0'); this.video.focus({preventScroll:true});
      try { await this.video.play(); } catch (_) {
        this.status.textContent = 'Use the video controls to start playback.'; this.status.hidden = false;
      }
    }
  }
  customElements.define('icraft-home-film', IcraftHomeFilm);
}

if (!customElements.get('icraft-review-carousel')) {
  class IcraftReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.slides = [...this.querySelectorAll('[data-review-id]')];
      this.index = 0; this.busy = false; this.animations = [];
      if (!this.slides.length) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.classList.add('is-ready');
      this.slides.forEach((slide, i) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `${i + 1} of ${this.slides.length}`);
      });
      this.update();
      this.onState = () => this.schedule();
      this.onMotion = () => { this.update(); this.schedule(); };
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.schedule();
      }, {threshold: 0.15});
      this.observer.observe(this);
      this.onBlock = event => {
        const index = this.slides.findIndex(slide => slide.dataset.reviewId === event.detail.blockId);
        if (index >= 0) this.go(index, index >= this.index ? 1 : -1, true);
      };
      this.addEventListener('focusin', this.onState);
      this.addEventListener('focusout', this.onState);
      document.addEventListener('visibilitychange', this.onState);
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('shopify:block:select', this.onBlock);
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.connected || !this.visible || document.hidden || this.motion.matches || this.slides.length < 2) return;
      this.timer = setTimeout(() => {
        if (!this.matches(':focus-within')) this.go(this.index + 1, 1);
        this.schedule();
      }, 12000);
    }
    update() {
      this.classList.toggle('is-ready', !this.motion.matches);
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        const hidden = !this.motion.matches && i !== this.index;
        slide.inert = hidden;
        slide.setAttribute('aria-hidden', String(hidden));
      });
    }
    async go(target, direction, instant = false) {
      if (this.busy || this.slides.length < 2) return;
      target = (target + this.slides.length) % this.slides.length;
      if (target === this.index) return;
      const previous = this.slides[this.index];
      this.index = target;
      this.update();
      if (instant || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.busy = true;
      const next = this.slides[target];
      const options = {duration: 320, easing: 'cubic-bezier(.22,.61,.36,1)'};
      this.animations = [
        previous.animate([{transform:'translateY(0)',opacity:1,visibility:'visible'},{transform:`translateY(${-direction * 100}%)`,opacity:0,visibility:'visible'}],options),
        next.animate([{transform:`translateY(${direction * 100}%)`,opacity:0},{transform:'translateY(0)',opacity:1}],options)
      ];
      await Promise.allSettled(this.animations.map(animation => animation.finished));
      this.busy = false;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.removeEventListener('focusin', this.onState);
      this.removeEventListener('focusout', this.onState);
      document.removeEventListener('visibilitychange', this.onState);
      this.motion?.removeEventListener('change', this.onMotion);
      document.removeEventListener('shopify:block:select', this.onBlock);
      this.connected = false;
    }
  }
  customElements.define('icraft-review-carousel', IcraftReviewCarousel);
}
